import React from 'react';
import { string } from 'prop-types';
import styled, { css } from 'styled-components';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_DBL, GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { GEL_LONG_PRIMER } from '@bbc/gel-foundations/typography';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
var GUIDANCE_BACKGROUND = 'rgba(34, 34, 34, 0.75)';
var GuidanceWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "GuidanceWrapper",
  componentId: "sc-1wm6qsk-0"
})(["", " ", ";width:100%;height:100%;position:absolute;border:0.0625rem solid transparent;color:", ";", " ", ""], function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
}, GEL_LONG_PRIMER, C_WHITE, function (_ref2) {
  var guidanceMessage = _ref2.guidanceMessage;
  return guidanceMessage ? "\n    background-color: ".concat(GUIDANCE_BACKGROUND, ";\n    @media screen and (-ms-high-contrast: active) {\n      background-color: transparent;\n    }") : "";
}, function (_ref3) {
  var noJsClassName = _ref3.noJsClassName;
  return noJsClassName && css([".", " &{background-color:", ";@media screen and (-ms-high-contrast:active){background-color:transparent;}.guidance-message{display:none;}}"], noJsClassName, GUIDANCE_BACKGROUND);
});
var GuidanceMessage = /*#__PURE__*/styled.strong.withConfig({
  displayName: "GuidanceMessage",
  componentId: "sc-1wm6qsk-1"
})(["display:block;font-weight:normal;padding:", ";border-bottom:0.0625rem solid transparent;@media screen and (-ms-high-contrast:active){background-color:window;}@media (min-width:", "){padding:", ";}"], GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_SPACING_DBL);
var StyledNoScript = /*#__PURE__*/styled.noscript.withConfig({
  displayName: "StyledNoScript",
  componentId: "sc-1wm6qsk-2"
})(["position:absolute;bottom:0;", ""], function (_ref4) {
  var noJsClassName = _ref4.noJsClassName;
  return !noJsClassName && css(["display:none;"]);
});

var Guidance = function Guidance(_ref5) {
  var guidanceMessage = _ref5.guidanceMessage,
      service = _ref5.service,
      noJsMessage = _ref5.noJsMessage,
      noJsClassName = _ref5.noJsClassName;
  return /*#__PURE__*/React.createElement(GuidanceWrapper, {
    service: service,
    guidanceMessage: guidanceMessage,
    noJsClassName: noJsClassName
  }, guidanceMessage && /*#__PURE__*/React.createElement(GuidanceMessage, {
    className: "guidance-message",
    "aria-hidden": "true"
  }, guidanceMessage), /*#__PURE__*/React.createElement(StyledNoScript, {
    noJsClassName: noJsClassName
  }, /*#__PURE__*/React.createElement(GuidanceMessage, null, noJsMessage)));
};

Guidance.propTypes = {
  guidanceMessage: string,
  service: string.isRequired,
  noJsMessage: string.isRequired,
  noJsClassName: string
};
Guidance.defaultProps = {
  guidanceMessage: null,
  noJsClassName: null
};
export default Guidance;